import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import useModalState from "hooks/useModalState";
import Modal from "modules/Modal/Modal";
import MDAlert from "components/MDAlert";
import useGetJobWorkOrder from "hooks/jobs/useGetJobWorkOrder";
import { Icon, IconButton, Skeleton, Tooltip } from "@mui/material";
import { JobPhase } from "generated/graphql";
import WorkOrderComponent from "pages/jobs/WorkOrderComponent";

export default function WorkOrderModal({
  jobPhaseId,
  open,
  onClose,
  onOpen,
  hideTrigger = false,
  variant = "icon",
}: {
  jobPhaseId: string | null;
  open?: boolean;
  onClose?: () => void;
  onOpen?: () => void;
  hideTrigger?: boolean;
  variant?: "icon" | "button";
}) {
  const modalState = useModalState();
  const isControlled = open !== undefined && onClose !== undefined;
  const modalOpen = isControlled ? open : modalState.open;
  const handleClose = isControlled ? onClose : modalState.onClose;
  const handleOpen = isControlled ? onOpen ?? (() => undefined) : modalState.onOpen;

  const { loading, error, data } = useGetJobWorkOrder(jobPhaseId);

  return (
    <>
      {!hideTrigger ? (
        <MDBox>
          {variant === "button" ? (
            <MDButton size="small" type="button" color="blue" onClick={handleOpen}>
              Work Order
            </MDButton>
          ) : (
            <Tooltip title="Work Order" arrow placement="top">
              <IconButton
                size="small"
                onClick={handleOpen}
                sx={{
                  border: "1px solid #d0d7e2",
                  borderRadius: "10px",
                  p: 0.75,
                  color: "#1a73e8",
                }}
              >
                <Icon fontSize="small">description</Icon>
              </IconButton>
            </Tooltip>
          )}
        </MDBox>
      ) : null}
      <Modal open={modalOpen} onClose={handleClose}>
        <MDBox p={3}>
          {!jobPhaseId || loading ? <Skeleton variant="rectangular" height={320} /> : null}
          {!loading && error ? <MDAlert color="error">Failed to load work order.</MDAlert> : null}
          {!loading && !error && data ? (
            <WorkOrderComponent data={data as JobPhase} isModal />
          ) : null}
        </MDBox>
      </Modal>
    </>
  );
}
